var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "br (2) 1",
    clipPath: "url(#clip0_4765_18717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_18717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 26.6191C20.1797 26.6191 26 20.7988 26 13.6191C26 6.43944 20.1797 0.619141 13 0.619141C5.8203 0.619141 0 6.43944 0 13.6191C0 20.7988 5.8203 26.6191 13 26.6191Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_18717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 0.619141H26V26.6191H0V0.619141Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 5.70703L23.7402 13.6188L13 21.5305L2.25977 13.6188L13 5.70703Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.84612 11.8417C8.59346 12.4229 8.46876 13.0515 8.48049 13.6851L16.7071 16.214C17.0695 15.6963 17.3187 15.108 17.4383 14.4874C15.3766 11.1714 11.3598 10.4097 8.8512 11.8468L8.84612 11.8417Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.9848 9.09963C12.2421 9.1015 11.5113 9.28638 10.857 9.63791C9.95658 10.1237 9.24762 10.9007 8.84609 11.8418C10.3847 11.5151 11.9813 11.5871 13.4842 12.0511C14.9871 12.515 16.3465 13.3555 17.4332 14.4926C17.6351 13.4645 17.4735 12.3983 16.9762 11.4762C16.5883 10.7559 16.0121 10.1544 15.3092 9.73585C14.6062 9.31731 13.8029 9.09741 12.9848 9.09963ZM10.7656 13.3399C9.99072 13.3373 9.22001 13.4537 8.48047 13.6852C8.48902 14.4102 8.6719 15.1226 9.01367 15.7621C9.29491 16.2851 9.67646 16.7476 10.1365 17.123C10.5966 17.4985 11.1261 17.7796 11.6948 17.9504C12.2636 18.1211 12.8604 18.178 13.4512 18.118C14.042 18.0579 14.6151 17.8821 15.1379 17.6004C15.7586 17.2662 16.2924 16.7914 16.6969 16.2141C15.9841 15.3242 15.0819 14.6044 14.0558 14.1072C13.0298 13.61 11.9058 13.3478 10.7656 13.3399Z",
    fill: "#0052B4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4765_18717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.619141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.bf4168c1ca26c9a0e4e34fa2d68bbdda.svg";
export { ForwardRef as ReactComponent };